import { Chip, Typography } from '@mui/material';

const CustomChip = ({ label, sx, ...props }) => {
  return (
    <Chip
      {...props}
      sx={{
        height: '20px',
        padding: '1px 2px',
        background: "var(--background-primary)",
        ...sx
      }}
      label={<Typography variant="body2">{label}</Typography>}
      size="small"
    />
  );
};

export default CustomChip;
